<template>
<div>
    <section class="page-title" style="background: linear-gradient(to right, #00695C, #4DB6AC);">
      <!-- <v-img 
        
        class="white--text"
        gradient="to right, rgba(3, 73, 236, .8), rgba(3, 73, 236, .8)"
        max-width="100%"          
      > -->
    <div class="center" v-if="!exibeformulario">
      <v-layout row wrap>
        <v-flex xs12 sm12 lg12>
        <p class="label-planos" style="color:white">Convênio Plano Odontológico</p>
        <h1 class="the-title" style="color:white">Inclua já <span style="color:#f6e03c;">seus dependentes</span> </h1>
<!--         <h1 class="the-title" style="font-size:40px;color:#f6e03c;">Inclua dependentes</h1> -->
        <p style="color:white">Essa plataforma é exclusiva para a inclusão de dependentes em contratos já existentes</p>
        <p style="color:white">Inclua agora mesmo, Cônjuge, Filho, Pai/Mãe, Irmão(a), Sobrinho(a), Neto(a) </p>
<!--         <v-checkbox
            v-model="contrataccept"
              label=""
              color="#d10a10"             
          >  
          <span slot="label">Confirmo a atualização dos dados cadastrais junto à CAARJ, para envio ao Plano Odontológico PrimaVida Dental.</span>                  
          </v-checkbox> -->
          <br>
          <v-card
          flat
          max-height="600px"
          max-width="500px"
          
          style="border: 1px solid; border-color: #194383;border-radius: 10px;">
          <v-card-text>
              <v-flex xs12 sm12 lg10>
              <v-container grid-list-md>
              <v-layout align-center justify-center row wrap>
              <v-flex xs12 sm12 lg8>      
              <v-text-field
              v-model="cpf"
              label="Digite o CPF"
              v-validate="'required|cpf'"
              :error-messages="errors.collect('cpf')"
              mask="###.###.###-##"
              color="#00796B"
              data-vv-name="cpf"        
              ></v-text-field>
              </v-flex>    
              <v-flex xs7 sm7 md7 lg3 >
              <v-btn
              style="border-radius: 6px;"               
              dark
              @click="consultaTitular()"
              color="#00796B"
              :loading="loading"
              >Incluir</v-btn>
            </v-flex>
              </v-layout>
              </v-container>
              </v-flex>
          </v-card-text>
          </v-card>
        </v-flex>           
        </v-layout>
    </div>
<!-- </section>

<section class="page-content center"> -->
  <div class="center" v-else>
    <v-flex xs12 sm12 lg12  >
    <div class="plano-selecionado" style="background: #f1f1f1;color:#194383;"><span style="color:#194383;">INCLUSÃO DE DEPENDENTES - {{nomePlano}}</span></div>
    <v-stepper v-model="e1"  style="border-radius: 10px;">
    <v-stepper-header>

      <v-stepper-step :complete="e1 > 1" step="1" :editable="editPassos" >Dados Pessoais</v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step :complete="e1 > 2" step="2" :editable="editPassos">Endereço</v-stepper-step>

<v-divider></v-divider>

      <v-stepper-step :complete="e1 > 3" step="3" :editable="editPassos">Beneficiários</v-stepper-step>

    </v-stepper-header>
    <v-stepper-items>

<!-- PASSO 1 -->
  <v-stepper-content step="1">
    <v-container grid-list-md>
        <v-card
          flat         
        >
        <v-layout row wrap>
            <v-flex xs12 sm12 lg12>      
            <v-text-field
            disabled
            v-model="financialManagers.firstName"
            label="Nome Completo"
            box
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg8>      
            <v-text-field
            disabled
            v-model="financialManagers.email"
            label="E-mail"
            box
            v-validate="'required|email'"
            :error-messages="errors.collect('email')"
            data-vv-name="email"
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg4>      
            <v-text-field
            disabled
            v-model="financialManagers.cellPhone"
            label="Tefefone"
            return-masked-value mask="(##)#####-####"
            box
            v-validate="'required'"
            :error-messages="errors.collect('cellPhone')"
            data-vv-name="cellPhone"
            ></v-text-field>
            </v-flex>
            <!-- <v-flex xs12 sm12 md12 lg12>
            <v-checkbox
            v-model="acceptTermos"
              color="#d10a10"
          >
          <span slot="label">Li o <a @click.stop :href="'https://ecommerce.primavida.com.br/contratos/Termo_uso_dados.pdf'" target="popup" :onclick="`window.open('http://www.primavida.com.br',popup,width=800,height=600); return false;`">termo em anexo</a> e confirmo a minha aceitação, no qual estou de acordo com a Politica de Privacidade da PrimaVida Dental.</span>
          </v-checkbox>
          </v-flex>  -->
      <v-flex md12 xs12 sm12 lg3>
        <v-btn
            style="border-radius: 8px;"
            large                
            dark
            color="#194383"
            @click="avancaPasso1()"
            >Continuar
        </v-btn>
      </v-flex> 
        </v-layout>
        </v-card>
        </v-container>
      </v-stepper-content>
    <!-- FIM DO PASSO 1 -->

    <!-- PASSO 2 --> 
      <v-stepper-content step="2">
        <v-container grid-list-md>
        <v-card
          flat
        >
        <v-layout row wrap>
            <v-flex xs12 sm12 lg2>      
            <v-text-field
            :disabled="cep != ''"
            v-model="cep"
            label="CEP"
            return-masked-value mask="#####-###"
            v-validate="'required'"
            :error-messages="errors.collect('cep')"
            data-vv-name="cep"
            box
            
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg7>      
            <v-text-field
            :disabled="cep != ''"
            v-model="carrj.rua"
            label="Rua"
            box
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg3>      
            <v-text-field
            :disabled="cep != ''"
            v-model="carrj.numero"
            label="Número"
            type="number"
            v-validate="'required'"
            :error-messages="errors.collect('numero')"
            data-vv-name="numero"
            box
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg4>      
            <v-text-field
            :disabled="cep != ''"
            v-model="carrj.bairro"
            label="Bairro"
            box
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg4>      
            <v-text-field
            :disabled="cep != ''"
            v-model="carrj.cidade"
            label="Cidade"
            box
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg4>      
            <v-text-field
            :disabled="cep != ''"
            v-model="carrj.estado"
            label="Estado"
            box
            ></v-text-field>
            </v-flex>
<!--             <v-flex xs12 sm12 lg12>
            <v-text-field
            v-model="carrj.complemento"
            label="Complemento"
            box
            ></v-text-field>
            </v-flex> -->
            <br>
            <v-flex xs12 sm2 lg3>
        <v-btn
            style="border-radius: 8px;"
            large                
            dark
            color="#194383"
            @click="avancaPasso3()"
            >Continuar
        </v-btn>   
        </v-flex>  
        </v-layout>
        </v-card>                
        </v-container>
      </v-stepper-content>

      <!-- FIM DO PASSO 2 -->

      <!-- PASSO 3 -->
  <v-stepper-content step="3">  
    <v-container fluid grid-list-md>
    <v-data-iterator
      v-if="dependentes != ''"
      :items="dependentes"
      :rows-per-page-items="rowsPerPageItems"
      rows-per-page-text="Linhas por página" 
      :pagination.sync="pagination"
      content-tag="v-layout"
      row
      wrap
      hide-actions
    >
      <template v-slot:header>
        <v-toolbar
          style="border-radius: 10px;"
          class="mb-2"
          color="#105586"
          dark
          flat
        >
    <v-toolbar-title>Dependentes</v-toolbar-title>
      </v-toolbar>
      </template>
      <template v-slot:item="props">
        <v-flex
          xs12
          sm6
          md4
          lg4
        >
          <v-card style="border-radius: 10px;">
            <v-card-title style="justify-content: center;" class="subheading font-weight-bold">{{ props.item.firstName.toUpperCase() }} - ({{ props.item.parentage == '' ? 'TITULAR' : props.item.parentage}})</v-card-title>

            <v-divider></v-divider>

            <v-list dense>
              
    <!--           <v-list-tile>
                <v-list-tile-content class="centralizar" >{{ props.item.parentage == '' ? 'TITULAR' : props.item.parentage}}</v-list-tile-content>
              </v-list-tile> -->

<!--               <v-list-tile>
                <v-list-tile-content class="centralizar" >R$ {{ props.item.valuePlan }},00</v-list-tile-content>
              </v-list-tile>   -->            

              <v-list-tile>                
                <v-btn
                style="border-radius: 8px;"                                
                dark
                color="blue-grey darken-1"
                @click="editItem(props.item)"
                >Editar
                </v-btn>
                <v-btn
                v-if="!props.item.isHolder"
                style="border-radius: 8px;"                                
                dark
                color="error"
                @click="openDialogDelete(props.item)"
                >Excluir
                </v-btn>                
              </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>
      </template>      
    </v-data-iterator>
  </v-container>
    <!-- DIALOG DA LISTA DE BENEFICIARIOS -->
    <v-flex xs12 sm12 lg12>
      <v-container grid-list-md v-if="!alertTitular">
        <v-layout row wrap justify-center>
          <v-btn
            @click="openDialogDependete()"                 
            dark              
            style="border-radius: 8px;"
            large                
            color="#cc9966"
            >
            Incluir Dependente
            </v-btn>
        </v-layout>
      </v-container>         
  </v-flex>
    <v-dialog v-model="dialog" max-width="950px" persistent>                      
      <v-card>                                                        
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>                               
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>               
              <v-flex xs12 sm12 lg4
              v-if="!dependents.isHolder">      
                <v-select                
                v-model="dependents.parentage"
                label="Parentesco"
                v-validate="'required'"
                :error-messages="errors.collect('parentage')"
                data-vv-name="parentage"
                :items="parentesco"
                item-text="text"
                item-value="value"
                box
                ></v-select>
                </v-flex>
              <v-flex xs12 sm12 lg8
              v-if="!dependents.isHolder">      
                <v-text-field
                v-model="dependents.firstName"
                label="Nome Completo"
                box
                v-validate="'required'"
                :error-messages="errors.collect('firstNameDep')"
                data-vv-name="firstNameDep"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 lg12
              v-else>      
                <v-text-field
                v-model="dependents.firstName"
                label="Nome Completo"
                box
                v-validate="'required'"
                :error-messages="errors.collect('firstNameDep')"
                data-vv-name="firstNameDep"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 lg4>      
                <v-text-field
                v-model="dependents.cpf"
                label="CPF"
                v-validate="'required|cpf'"
                :error-messages="errors.collect('cpfDep')"
                return-masked-value mask="###.###.###-##"
                data-vv-name="cpfDep"
                box
                ></v-text-field>
                </v-flex>              
                <v-flex xs12 sm12 lg4>      
                <v-text-field
                v-model="dataNascDependent"
                label="Data de Nascimento"
                v-validate="'required|date_format:dd/MM/yyyy'"
                :error-messages="errors.collect('dateOfBirthDep')"
                return-masked-value mask="##/##/####"
                data-vv-name="dateOfBirthDep"
                box
                ></v-text-field>
                </v-flex>                            
                <v-flex xs12 sm12 lg4>      
                <v-text-field
                v-model="dependents.susNumber"
                label="CNS (Cartão do SUS)"
                box
                ></v-text-field>
                </v-flex> 
                <v-flex xs12 sm12 lg3>      
                <v-select
                v-model="dependents.maritalStatus"
                label="Estado Civil"
                v-validate="'required'"
                :error-messages="errors.collect('maritalStatusDep')"
                data-vv-name="maritalStatusDep"
                :items="estadoscivil"
                item-text="text"
                item-value="value"
                box
                ></v-select>
            </v-flex>
              <v-flex xs12 sm12 lg3>      
                <v-select
                v-model="dependents.gender"
                label="Sexo"
                v-validate="'required'"
                :error-messages="errors.collect('genderDep')"
                data-vv-name="genderDep"
                :items="generos"
                item-text="text"
                item-value="value"
                box
                ></v-select>
                </v-flex>               
                <v-flex xs12 sm12 lg6>      
                <v-text-field
                v-model="dependents.motherName"
                label="Nome da Mãe"
                v-validate="'required'"
                :error-messages="errors.collect('motherNameDep')"
                data-vv-name="motherNameDep"
                box
                ></v-text-field>
                </v-flex>                                                    
            </v-layout>
            </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>        
          <v-btn dark color="blue-grey darken-1" style="border-radius: 8px; width: 130px;" @click.native="salvarDependente">Salvar</v-btn>
          <v-btn dark color="red darken-1" style="border-radius: 8px; width: 130px;" @click.native="close">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- FIM DIALOG DEPENDENTES --> 

     <!-- DIALOG DELETA DEPENDENTE -->
    <v-dialog v-model="dialogDelete" max-width="600px" persistent> 
      <v-card>
        <v-card-title>
          <span class="headline">Confirmação de Exclusão</span>
        </v-card-title>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-card-text>Dependente: {{dependents.firstName}}</v-card-text>
              <v-card-text>Parentesco: {{dependents.parentage}}</v-card-text>
            </v-layout>
          </v-container>
          <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn dark color="red darken-1" style="border-radius: 8px; width: 130px;" @click.native="deleteDependente(dependents.firstName)">Excluir</v-btn>
          <v-btn dark color="blue-grey darken-1" style="border-radius: 8px; width: 130px;" @click.native="close">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- FIM DIALOG DELETA DEPENDENTE -->     
    
        <br>
        <v-flex xs12 sm12 lg12 v-if="alertTitular">
          <v-container grid-list-md>
            <v-layout row wrap justify-center>
              <v-btn
                style="border-radius: 8px;"
                large                
                dark
                color="#cc9966"
                @click="openDialog()"
                >Incluir Titular
            </v-btn>
            </v-layout>
          </v-container>
          <br>
          <br>
        </v-flex>
    <div class="separator dark"></div>
    <v-container grid-list-md>
        <v-layout row wrap justify-center>
          <v-flex xs12 sm12 lg12>
            <div class="total-table">
                <p class="form-titulo">Valores</p>
                <div class="row-table-wrapper">                  
                    <div class="col" style="width: 36%;">
                        <div class="row-table titular" v-if="estagiario">
                            <p>Beneficiário Titular</p>
                            <span class="total">R$ 15,00</span>
                        </div>
                        <div class="row-table dependentes-row">
                            <p>Dependente(s)</p>
                            <span class="total">R$ {{valorDependentes.replace('.',',')}}</span>
                        </div>
                    </div>
                 
                    <div class="col" style="margin-right: 14%;">
                        <div class="row-table total-row">
                            <p>Total a pagar</p>
                            <span class="total">R$ {{valorTotalProposta.replace('.',',')}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <hr>
            <br>
          </v-flex>
      <v-flex xs12 sm12 lg12>    
            <p class="form-titulo" >Corretor</p>          
          <v-flex xs12 sm12 lg12>            
            <v-radio-group v-model="vendedor.temVendedor" row :disabled="vendedor.linkVendedor" >
                <strong class="row-table dependentes-row" style="font-weight: bold;color:#797a7a">Você foi auxiliado por algum corretor? &nbsp;&nbsp;</strong>
                <v-radio color="#105586" label="Sim" :value="true"></v-radio>
                <v-radio color="#105586" label="Não" :value="false"></v-radio>
            </v-radio-group>
            </v-flex>
          <v-flex xs12 sm12 lg4 v-if="!vendedor.linkVendedor">
                <v-text-field                
                v-if="vendedor.temVendedor ? true : vendedor.cpfVendedor = ''"
                v-model="vendedor.cpfVendedor"
                label="CPF" 
                v-validate="'required|cpf'"
                :error-messages="errors.collect('cpfCorretor')"
                data-vv-name="cpfCorretor"         
                box
                return-masked-value mask="###.###.###-##"
                :keyup="consultaVendedor()"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 lg8>      
            <v-text-field
            v-if="vendedor.temVendedor ? vendedor.temVendedor == true : vendedor.nomeVendedor = ''"
            v-model="vendedor.nomeVendedor"
            label="Corretor"
            box
            disabled
            ></v-text-field>
            </v-flex>
            </v-flex>
        </v-layout>
      </v-container>    
     <!-- FIM DO DIALOG DA LISTA DE BENEFICIARIOS -->
    <v-card-actions>      
      <v-flex md12 xs12 sm12 lg3>
        <v-btn
            style="border-radius: 8px;"
            large                
            dark
            color="#194383"
            @click="enviarCodigo()"
            :loading="loadingFinal"
            >Finalizar e enviar
        </v-btn>
      </v-flex>         
    </v-card-actions>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
<!-- FIM DO PASSO 3 -->
      

  <v-dialog v-model="dialogLoading" max-width="600px" max-height="500px" persistent> 
      <v-card style="border: 1px solid; border-color: #194383;border-radius: 10px;">
          <v-container grid-list-md>
            <v-layout row wrap justify-center>
              <v-card-title>
              <span class="total" style="font-size:1.7rem;">Cadastro concluído com sucesso</span>              
              </v-card-title>
              <v-container
                    fluid
                    justify-center
                    class="resumo"
                  >
              <p>Sua proposta de inclusão de dependetes foi enviada à Primavida Dental para análise!</p>
              </v-container>
            </v-layout>
            <v-card-actions>
              <v-container
                    fill-height
                    fluid
                    pa-1
                    justify-center
                  >
              <v-btn color="blue-grey darken-1" v-if="!loadingFinal" style="border-radius: 8px; width: 130px;" dark @click="confirmaContrato()">Fechar</v-btn>
              </v-container>
            </v-card-actions>
          </v-container>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogConfirmacao" max-width="450px" max-height="500px" persistent> 
      <v-card style="border: 1px solid; border-color: #194383;border-radius: 10px;">
          <v-container grid-list-md>
            <v-layout row wrap justify-center>
              <v-card-title>
              <span class="total" style="font-size:1.7rem;">Confirme a sua inclusão</span>              
              </v-card-title>
              <v-container
                    fluid
                    justify-center
                    class="resumo"
                  >                              
              <p class="resumo">Um E-mail foi enviado para <strong class="subheading font-weight-bold">{{financialManagers.email}} </strong> com o código de confirmação da inclusão que deverá ser informado no campo abaixo:</p>
              <br>
              <v-flex xs12 sm12 lg12>      
                <v-text-field
                v-model="codigoConfirmacao"
                label="Código de confirmação"
                box
                ></v-text-field>
                </v-flex>              
              </v-container>
            </v-layout>
            <v-card-actions>
              <v-container
                    fill-height
                    fluid
                    pa-1
                    justify-center
                  >
              <v-btn color="blue-grey darken-1" style="border-radius: 8px; width: 130px;" dark @click="finalizarProposta()">Confirmar</v-btn>
              <v-btn dark color="red darken-1" style="border-radius: 8px; width: 130px;" @click="close()">Cancelar</v-btn>
              </v-container>
            </v-card-actions>
          </v-container>
      </v-card>
    </v-dialog>

   </v-flex>   
  </div>    
</section>
<loading :active.sync="isLoading" 
        :can-cancel="true" 
        color="#105586"
  :is-full-page="fullPage"></loading>
<Snackbar ref=chamaSnackbar />
</div>
</template>
<script>
import Snackbar from '../components/snackbar.vue'
import axios from 'axios'
import { mapState } from 'vuex'
import { baseApiUrl } from '@/global'
import CpfValidate from '../components/validators/rules/cpf'
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
    components: {Snackbar, Loading},
     data(){
        return{
            fullPage: true,  
            isLoading: false,          
            contratoCancelado: false,
            estagiario: false,
            valorContrato: 'ISENTO',
            mensagemS4E: [],
            planoId: '',
            nomePlano: '',
            TitulaEmail: '',
            TitularFone: '',
            cpf: '',
            senha: '',
            idAssociado: '',
            possuiContrato: false,
            exibeformulario: false,
            exibesenha: false,
            rowsPerPageItems: [12, 18],
            pagination: {
              rowsPerPage: 12
            },
            qtdDependentesInseridos: 0,
            pdfSelecionado: 8,
            verificaTitularS4e: '',
            pagCartao: false,
            loadingFinal: false,
            loading: false,
            financialManagUF: '',
            contrataccept: false,
            acceptTermos: false,            
            alertTitular: false,
            editPassos: false,
            editedIndex: '',
            editedIndexTitular: '',
            valorDependentes: '0,00',
            valorTotalProposta: '0,00',
            valorTitular: '0,00',
            valorFaixa: '0,00',
            search: '',
            dialog: false,
            dialogDelete: false,
            dialogLoading: false,
            dialogConfirmacao: false,
            codigoConfirmacao: '',
            codigoRecebido: '',
            dependentes: [], 
            dependentesCaarj: [],
            titularContrato: [],
            vendedor:{
              nomeVendedor: '',
              temVendedor: false,
              linkVendedor: false,
              cpfVendedor: '',
            },
            e1: 0,
            bairro: '',
            cidade: '',
            estado: '',
            estados: [],
            parentesco: [  
            { value: 'CÔNJUGE', text: "CÔNJUGE" },
            { value: 'FILHO', text: "FILHO(A)" },            
            { value: 'ENTEADO', text: "ENTEADO(A)" },
            { value: 'OUTRO', text: "OUTRO" }, 
            ],
            generos: [
            { value: 1, text: "Masculino" },
            { value: 0, text: "Feminino" } ],
            estadoscivil: [
            { value: "SOLTEIRO", text: "Solteiro(a)" },
            { value: "CASADO", text: "Casado(a)" },
            { value: "VIÚVO", text: "Viúvo(a)" },
            { value: "DIVORCIADO", text: "Divorciado(a)" } ],
            planoSelecionado: [],
            dataNasc: '',
            dataNascDependent: '',
            dependents: {
              id: '',
              parentage: '',
              valuePlan: '',
              lackOfCare: 1,
              rcaId: '',
              dateFirstPayment: '',
              isHolder: '',
              financialManagerId: '',
              firstName: '',
              lastName: '',
              dateOfBirth: '',
              gender: '',
              maritalStatus: '',
              cpf: '',
              motherName: '',
              susNumber: '',
              plansId: ''
            },
            defaultDependents: {
              id: '',
              parentage: '',
              valuePlan: '',
              lackOfCare: 1,
              rcaId: '',
              dateFirstPayment: '',
              isHolder: '',
              financialManagerId: '',
              firstName: '',
              lastName: '',
              dateOfBirth: '',
              gender: '',
              maritalStatus: '',
              cpf: '',
              motherName: '',
              susNumber: '',
              plansId: ''
            },
            financialManagers:{
                contratanteTitular: true,
                confirmPassword: '',
                password: '',
                rg: '',
                rgEmitter: '',
                homePhone: '',
                cellPhone: '',
                cellPhone2: '',
                email: '',
                cep: '',
                address: '',
                addressType: '',
                addressTypeName: '',
                addressNumber: '',
                addressComplement: '',
                district: '',
                city: '',
                state: '',
                proposalNumber: '',
                contractNumberS4: '',
                responsibility: '',
                cardNumber: '',
                cardValidity: '',
                cardFlag: '',
                cardDayExpiration: 15,
                dateSignatureContract: '',
                formOfPaymentId: '',
                firstName: '',
                lastName: '',
                dateOfBirth: '',
                gender: null,
                maritalStatus: null,
                cpf: '',
                motherName: '',
                susNumber: '',
                plansId: '',
                nsu: '',
                planoSelecionado: [],
                typeFm: 'FISICA',
                protocoloCancelamento: '',
                vendedor: '',
                matricula: '' 
            },
            
            caarjDependente: {
                tipo: '',
                nome: '',
                dataNascimento: '',
                cpf: '',
                sexo: '',
                plano: '',
                planoValor: '',
                nomeMae: '',
                telefoneFixo: '',
                celular:'',
                celular2:'',
                email:''
              },
            caarjDependenteDefalt: {
                tipo: '',
                nome: '',
                dataNascimento: '',
                cpf: '',
                sexo: '',
                nomeMae: '',
                telefoneFixo: '',
                celular:'',
                celular2:'',
                email:'',
                numeroProposta:''
              },  
              ativarAssociado: {
                codigoAssociado: "",
                codigoEmpresa: "",
                tipoSolicitante: "1",
                codigoSituacao: "1",
                comentario: "",
                motivoCancelamento: "13",
                dataFimAtendimento: "",
                protocolo: ""
              },
            
            caarjS4E:{
              codigoParceiro: 62247,
              codigoResponsavelFinanceiro: '',
              dependente: []
          },

          caarjS4EDefault:{
              codigoParceiro: 62247,
              codigoResponsavelFinanceiro: '',
              dependente: []
          },
            cep: '',
            carrj: {
              titular: '',
              cpf: '',
              sexo: '',
              rg: '',
              nascimento: '',
              cep: '',
              contrato: '',
              email: '',
              telefone: '',
              dependentes: [],
              numero: '',
              complemento: '',
              enviado: 'pendente',
              data: new Date().toLocaleString(),
              rua: '',
              cidade: '',
              estado: '',
              bairro: '',
              contratoEmpresa: ''
            },
            dependentesCarregados: [],
            steppers: {
              default: 0,
              type: Number
            },
            formOfPayment: {
              uf: '',
              dayInclusion: '',
              type: ''
            },
            idUf: '',
            idUser: '',
            dictionary: {          
                custom: {
                uf: {
                    required: () => 'Informe a UF',
                },
                firstName: {
                    required: () => 'Informe o Nome',                   
                },
                firstNameDep: {
                    required: () => 'Informe o Nome',                   
                },
                email: {
                    required: () => 'Informe o Email',
                    email: () => 'Informe um Email válido'
                },
                cellPhone: {
                    required: () => 'Informe o Telefone',                   
                },
                password: {
                    required: () => 'Informe a Senha',
                    confirmed: () => 'A senha não confere'
                },
                senha: {
                    required: () => 'Informe a Senha'
                },
                dateOfBirth: {
                   required: () => 'Informe a Data de Nascimento' 
                },
                dateOfBirthDep: {
                   required: () => 'Informe a Data de Nascimento' ,
                   date_format:() => 'Data no formato errado'
                },
                gender: {
                   required: () => 'Informe o Sexo' 
                },
                genderDep: {
                   required: () => 'Informe o Sexo' 
                },
                maritalStatus: {
                   required: () => 'Informe o Estado Civil' 
                },
                maritalStatusDep: {
                   required: () => 'Informe o Estado Civil' 
                },
                motherName:{
                   required: () => 'Informe o nome da Mãe'
                },
                motherNameDep:{
                   required: () => 'Informe o nome da Mãe'
                },
                cep:{
                   required: () => 'Informe o CEP'
                },
                numero: {
                  required: () => 'Informe o Número, caso não tenha informe 0'
                },
                parentage: {
                  required: () => 'Informe o Parentesco'
                },
                cpfDep: {
                  required:() => 'Informe o CPF'
                },
                cpfCorretor: {
                  required:() => 'Informe o CPF'
                },            
            }
            } 

        }
    },

    mounted : function(){
      this.$store.dispatch('ExibeToolbar')
      this.$validator.localize('pt', this.dictionary)
      localStorage.clear()
      sessionStorage.clear() 
      this.pegaParametrosUrl()
        //this.titularSemEndereco()
    },
    watch: {
    dialog(val) {
    val || this.close()
      },
    cep(){
      if(this.cep.length == 9)
      this.retornoViaCEP()
    }
    },
    computed: { 
      ...mapState({
        userloggedin: state => state.userloggedin
    }),      
        formTitle() {
          return this.editedIndex === '' ? 'Incluir Dependente' : 'Editar Dependente'
        },
        minHeight () {
        switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '800px'
        case 'sm': return '800px'
        case 'md': return '800px'
        case 'lg': return '800px'
        case 'xl': return '800px'
      }
      return true
      }
    },
    methods: {
        editItem(item) {
          this.editedIndex = item.id
          this.editedIndexTitular = item.id
          this.dependents = Object.assign({}, item)
          this.dataNascDependent = this.formatDateBrz(this.dependents.dateOfBirth)
          this.dialog = true

        },
         async deleteDependente(firstName) {             
            this.dependentes.forEach( (item, index) => {
            // se o id do array de objetos estiver em a1
            if (item.firstName == firstName)
                this.dependentes.splice(index,1) // entao remove 
                this.calculaPlano(this.planoSelecionado)                             
            })

            this.dependentesCaarj.forEach( (item2, index2) => {
            // se o id do array de objetos estiver em a1
            if (item2.nome == firstName)
                this.dependentesCaarj.splice(index2,1) // entao remove 
                this.calculaPlano(this.planoSelecionado)
                this.close()                                
            })

 /*            if(this.dependentes == '')
            {
                this.valorDependentes = '0,00'
                this.valorTotalProposta = (parseFloat(this.valorTitular) + parseFloat(this.valorDependentes)).toFixed(2)
                this.calculaPlano(this.planoSelecionado)
                this.close()
            }
            else
            {
            this.dependentes.forEach( (item2) => {
                this.valorDependentes = '0,00'

                this.valorDependentes = (parseFloat(this.valorDependentes) + parseFloat(item2.valuePlan)).toFixed(2)
                this.valorTotalProposta = (parseFloat(this.valorTitular) + parseFloat(this.valorDependentes)).toFixed(2)
                this.close()
            })            
            } */
           
        },
        
        avancaPasso1(){
            //this.TitulaEmail =  this.financialManagers.email                     
            if(this.carrj.email == '' || this.carrj.telefone == '')
            this.$validator.validateAll()
            else
            if(this.planoSelecionado == undefined)
            {
              var vm2 = this;
              vm2.$refs.chamaSnackbar.snack("#F9A825","O plano contratado não foi encontrado, contate a Primavida Dental!","ATENÇÃO")
            }
            else
            this.e1 = 2
        }, 

        async avancaPasso3(){
          this.carrj.cep = this.cep
          if(this.carrj.cep == '' || this.carrj.rua == '' || this.carrj.bairro == '' || this.carrj.numero == '' || this.carrj.cidade == '' || this.carrj.estado == '')
          this.$validator.validateAll()
          else
            this.e1 = 3            
        },
      

    formatDate (date) {
        if (!date) return null

        const [day, month, year] = date.split('/')
        return `${year}-${month}-${day}`
      },
        formatDateBrz (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      formatDateCartao (date) {
        if (!date) return null

        const [year, month] = date.split('-')
        return `${month}/${year}`
      },

      async retornoViaCEP(){
          await axios
          .post(`${baseApiUrl}APIS4s/Endereco`, {"cep" : this.cep})
          .then(res => {        
            if(res.data != null){      
            this.financialManagers.address = res.data.Logradouro
            this.carrj.rua = res.data.Logradouro
            this.carrj.cidade = res.data.Municipio
            this.financialManagers.city = res.data.IdMunicipio
            this.carrj.estado = res.data.Uf
            this.financialManagers.state = res.data.IdUf
            this.carrj.bairro = res.data.Bairro
            this.financialManagers.district = res.data.IdBairro
            this.financialManagers.addressType = res.data.IdTipoLogradouro
            this.financialManagers.addressTypeName = res.data.TipoLogradouro
            }  
            else{
              var vmcep = this;
              vmcep.$refs.chamaSnackbar.snack("#F9A825","CEP não localizado!","ATENÇÃO")
            }         	
            })       
      },              
                 

      async salvarDependente(){
        if(this.dependents.cpf.replace(/\D/g, '') == this.cpf)
        {
          var vmcpf = this;
          vmcpf.$refs.chamaSnackbar.snack("#F9A825","O CPF do dependente não pode ser o mesmo do titular!","ATENÇÃO")
        }
        else{
        if(this.dataNascDependent == '' || this.dependents.fistName == '' || this.dependents.parentage == '' || this.dependents.motherName == '' || this.dataNascDependent.length != 10)
            this.$validator.validateAll()
        else
        if(this.calculateAge(this.dataNascDependent) >= 12 && this.dependents.cpf == '')
            this.$validator.validateAll() 
        else
        if(!CpfValidate(this.dependents.cpf) && this.dependents.cpf != '')
          this.$validator.validateAll()
        else
        {
        if(this.dependentesCarregados != '')
        {
        this.dependentesCarregados.forEach( (depcarr) => {
        // se o id do array de objetos estiver em a1
        if (depcarr.cpf == this.dependents.cpf){
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#F9A825","Dependente / Agregado já cadastrado!","ATENÇÃO")
        }
        else{
        this.dependentes.forEach( (item, index) => {
        // se o id do array de objetos estiver em a1
        if (item.id == this.dependents.id)
            this.dependentes.splice(index,1) // entao remove
        })
            this.caarjDependente.plano = this.planoId
            this.caarjDependente.tipo = this.dependents.parentage
            this.caarjDependente.sexo = this.dependents.gender
            this.caarjDependente.cpf = this.dependents.cpf
            this.dependents.id = Math.floor(1000 + Math.random() * 1000)
            this.dependents.dateOfBirth = this.formatDate(this.dataNascDependent)
            this.caarjDependente.dataNascimento = this.formatDate(this.dataNascDependent)
            this.dependents.financialManagerId = this.idUser
            this.dependents.isHolder = false
            this.dependents.firstName = this.dependents.firstName.toUpperCase()
            this.caarjDependente.nome = this.dependents.firstName.toUpperCase()
            this.dependents.motherName = this.dependents.motherName.toUpperCase()
            this.caarjDependente.nomeMae = this.dependents.motherName.toUpperCase()
            this.valorDependentes = '0,00'                          
            this.dependentes.push(this.dependents)
            this.calculaPlano(this.planoSelecionado)
            this.dependentesCaarj.push(this.caarjDependente)
            this.close()
        }
        })
        }
        else{

        this.dependentes.forEach( (item, index) => {
        // se o id do array de objetos estiver em a1
        if (item.id == this.dependents.id)
            this.dependentes.splice(index,1) // entao remove
        })
            this.caarjDependente.plano = this.planoId
            this.caarjDependente.tipo = this.dependents.parentage
            this.caarjDependente.sexo = this.dependents.gender
            this.caarjDependente.cpf = this.dependents.cpf
            this.dependents.id = Math.floor(1000 + Math.random() * 1000)
            this.dependents.dateOfBirth = this.formatDate(this.dataNascDependent)
            this.caarjDependente.dataNascimento = this.formatDate(this.dataNascDependent)
            this.dependents.financialManagerId = this.idUser
            this.dependents.isHolder = false
            this.dependents.firstName = this.dependents.firstName.toUpperCase()
            this.caarjDependente.nome = this.dependents.firstName.toUpperCase()
            this.dependents.motherName = this.dependents.motherName.toUpperCase()
            this.caarjDependente.nomeMae = this.dependents.motherName.toUpperCase()
            this.caarjDependente.numeroProposta = Math.floor(10000 + Math.random() * 10000).toString()
            this.valorDependentes = '0,00'                          
            this.dependentes.push(this.dependents)
            this.calculaPlano(this.planoSelecionado)
            this.dependentesCaarj.push(this.caarjDependente)
            this.close()
        }      

        }
      }
                    
      },

      calculaPlano(plano){
      this.valorFaixa = plano.value.replace(',','.')
      this.caarjDependente.planoValor = plano.value.replace(',','.')
      //Trata faixa de usuários  
          
      if(this.dependentes.length == 1 && plano.familyTable.value2 != '')
      {
      this.valorFaixa = plano.familyTable.value2.replace(',','.')
      this.dependents.valuePlan = plano.familyTable.value2.replace(',','.')
      this.caarjDependente.planoValor = plano.familyTable.value2.replace(',','.')
      
      }
      if(this.dependentes.length >= 2 && plano.familyTable.value3 == '')
      {
      this.valorFaixa = plano.familyTable.value2.replace(',','.')
      this.dependents.valuePlan = plano.familyTable.value2.replace(',','.')
      this.caarjDependente.planoValor = plano.familyTable.value2.replace(',','.')
           
      }
      if(this.dependentes.length >= 2 && plano.familyTable.value3 != '')
      {
      this.valorFaixa = plano.familyTable.value3.replace(',','.')
      this.dependents.valuePlan = plano.familyTable.value3.replace(',','.')
      this.caarjDependente.planoValor = plano.familyTable.value3.replace(',','.') 
           
      }


      if(plano.taxaImplantacao != '0,00')
      {
        var totalTaxa = 0      
        if(this.dependentes.length > 0)
        {
        totalTaxa = (parseFloat(plano.taxaImplantacao.replace(',','.')) * this.dependentes.length).toFixed(2)
        this.valorDependentes = (parseFloat(this.valorFaixa) * this.dependentes.length + parseFloat(totalTaxa)).toFixed(2)
        }
        else
        this.valorDependentes = '0.00'
        this.valorTotalProposta = parseFloat(this.valorDependentes).toFixed(2)
      }
      else{
        if(this.dependentes.length > 0)
        this.valorDependentes = (this.valorFaixa * this.dependentes.length).toFixed(2)
        else
        this.valorDependentes = '0.00'
        this.valorTotalProposta = parseFloat(this.valorDependentes).toFixed(2)
      }
    },




      openDialog(){
        this.tipoTitular = true
        this.$validator.reset()
          this.dependents = Object.assign({}, this.defaultDependents)
          this.editedIndexTitular = ''
          this.dataNascDependent = ''
          this.dependents.isHolder = true
        this.dialog = true
      },
      openDialogDependete(){
        if(this.dependentesCarregados != '')
        {
         var vm = this;
         vm.$refs.chamaSnackbar.snack("#F9A825","Contrato com dependentes / agregados já inseridos!","ATENÇÃO")
        }
        else
        {
        this.tipoTitular = false
        this.$validator.reset()
          this.dependents = Object.assign({}, this.defaultDependents)
          this.editedIndex = ''
          this.dataNascDependent = ''
        this.dialog = true
        }
      },
      openDialogDelete(item){
        this.editedIndex = item.id
        this.dependents = Object.assign({}, item)
        this.$validator.reset()
        this.dialogDelete = true
      },
      close() {
        this.dialogDelete = false
          this.dialogLoading = false
          this.dialog = false
          this.$validator.reset()          
          setTimeout(() => {
          this.dependents = Object.assign({}, this.defaultDependents)
          this.caarjDependente = Object.assign({}, this.caarjDependenteDefalt)
          this.editedIndex = ''
          this.editedIndexTitular = ''
          this.dataNascDependent = ''
          }, 300)
      },

      closeConfirmacao(){
        this.dialogConfirmacao = false
      },

      async enviarCodigo(){
        this.isLoading = true
        if(this.dependentes.length == 0)
        {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825","Para enviar uma solicitação de inclusão é necessário inserir pelo menos um dependente!","ATENÇÃO")
        }
        else
        {
        await axios.post(`${baseApiUrl}Sales/SendEmailTokenNewDependent`, {"email": this.financialManagers.email}).then(res => {                       
            if(res.data != '') {
            this.codigoRecebido = res.data.token
            this.isLoading = false
            this.dialogConfirmacao = true
            }
        })
        }      
      },

      async consultaTitular()
      {
          this.titularContrato = []
          this.possuiContrato = false
          var vm2
          if(this.cpf == '')
          {
              this.$validator.validateAll()
          }
          else
          {
          this.loading = true
          
          await axios.post(`${baseApiUrl}APIS4s/Associados`, {"cpf": this.cpf,"empresa": 0,"incluirDependentes":1}).then(res => {                       
            if(res.data.Data[0] != '') {
            this.loading = false 

            res.data.Data.forEach( (titular) => {
                    if(titular.Dependente[0].Situacao == "1")
                    {
                    this.possuiContrato = true
                    this.titularContrato = titular
                    this.caarjS4E.codigoResponsavelFinanceiro = titular.Id
                    this.planoId = titular.Dependente[0].IdPlano
                    this.nomePlano = titular.Dependente[0].NomePlano
                    this.ativarAssociado.codigoAssociado = titular.Dependente[0].Id
                    }
            })
/*             if(this.contratoCancelado)
            {
                vm2 = this;
                vm2.$refs.chamaSnackbar.snack("#F9A825","Situação do contrato não permite continuar, contate a Primavida Dental!","ATENÇÃO")
                this.loading = false                
                this.exibeformulario = false
            }
            else */
            if(!this.possuiContrato)
            {
                vm2 = this;
                vm2.$refs.chamaSnackbar.snack("#F9A825","Não foi encontrado contrato ativo para este CPF, contate à Primavida Dental","ATENÇÃO")
                this.loading = false                
                this.exibeformulario = false
            }else
            {
                this.financialManagers.firstName = this.titularContrato.Nome
                this.carrj.titular = this.titularContrato.Nome
                this.financialManagers.cpf = this.titularContrato.CPF
                this.carrj.cpf = this.titularContrato.CPF
                this.cep = this.titularContrato.Cep
                for(var i=0; i<this.titularContrato.Contato.length; i++) {
                  if(this.titularContrato.Contato[i].Tipo == 'E-mail' && this.titularContrato.Contato[i].situacao == 1)
                  {
                  this.financialManagers.email = this.titularContrato.Contato[i].descricao
                  this.carrj.email = this.titularContrato.Contato[i].descricao
                  }

                  if(this.titularContrato.Contato[i].Tipo == 'Celular' || this.titularContrato.Contato[i].Tipo == 'Telefone' && this.titularContrato.Contato[i].situacao == 1)
                  {
                  this.financialManagers.cellPhone = this.titularContrato.Contato[i].descricao
                  this.carrj.telefone = this.titularContrato.Contato[i].descricao
                  }
                }
                if(this.titularContrato.Sexo == 'M'){
                this.financialManagers.gender = 1
                this.carrj.sexo = 'MASCULINO'
                }    
                else
                {
                this.financialManagers.gender = 0
                this.carrj.sexo = 'FEMININO'
                }
                this.financialManagers.rg = this.titularContrato.Identidade
                this.carrj.rg = this.titularContrato.Identidade
                this.dataNasc = this.titularContrato.DataNascimento
                this.carrj.nascimento = this.titularContrato.DataNascimento
                this.carrj.contrato = this.titularContrato.Contrato
                this.carrj.numero = this.titularContrato.Numero                 
                this.carrj.complemento = this.titularContrato.Complemento
                this.financialManagers.addressNumber = this.titularContrato.Numero                 
                this.financialManagers.addressComplement = this.titularContrato.Complemento                           
                this.exibeformulario = true

            }
            }
            else
            {
            vm2 = this;
            vm2.$refs.chamaSnackbar.snack("#F9A825","Titular não localizado, entre em contato com a Primavida Dental","ATENÇÃO")
            this.loading = false                    
            }        	
            })

            if(this.planoId != '')
            {
              await axios.get(`${baseApiUrl}Plans?filter[where][codeS4]=${this.planoId}`).then(res => {        
              if(res.data != null){      
              this.planoSelecionado = res.data[0]
              }
          })
            }
          }                    

        },
        
        async ativarAssociadoS4E(){
           await axios.post(`${baseApiUrl}APIS4s/AtivarTitulares`, this.ativarAssociado)

        },

        async finalizarProposta(){
          var vm2;
          if(this.codigoConfirmacao == this.codigoRecebido)
          {
            this.isLoading = true

            var enviaDependentes = []
          if(this.dependentesCaarj != '')
            {
                  for(var i=0; i<this.dependentesCaarj.length; i++) {
                  this.dependentesCaarj[i].planoValor = this.valorFaixa
                  this.caarjS4E.dependente = this.dependentesCaarj[i]
                  enviaDependentes.push(this.caarjS4E)
                  this.caarjS4E = Object.assign({}, this.caarjS4EDefault)  
                  this.caarjS4E.codigoResponsavelFinanceiro =  this.titularContrato.Id 
                  } 

                  for(var i2=0; i2<enviaDependentes.length; i2++) {
                    this.carrj.dependentes.push(enviaDependentes[i2])
                  }           
            }
            setTimeout(() => {
                axios.post(`${baseApiUrl}InclusaoDependentes/replaceOrCreate`, this.carrj).then(res => {         
                if(res.data != ''){
                    this.isLoading = false 
                    this.closeConfirmacao()
                    this.dialogLoading = true                                
                  }              	
                  })
            }, 6000);
            
          }
          else
          {
            this.isLoading = false
            vm2 = this;
            vm2.$refs.chamaSnackbar.snack("#F9A825","O código de confirmação é inválido!","ATENÇÃO")
          }
        },
        confirmaContrato(){
        this.close()
        window.location.reload()
      },

    calculateAge(dobString) {        
        var dob = new Date(this.formatDate(dobString));
        var currentDate = new Date();
        var currentYear = currentDate.getFullYear();
        var birthdayThisYear = new Date(currentYear, dob.getMonth(), dob.getDate());
        var age = currentYear - dob.getFullYear();
        if(birthdayThisYear > currentDate) {
          age--;
        }
        return age;
      },

      async titularSemEndereco(){
        var listaCarrj = []
        await axios.get(`${baseApiUrl}caarjs?`).then(res => {                   
                if(res.data != ''){
                  res.data.forEach( (item) => {
                  if (item.cidade == undefined)
                     listaCarrj.push(item) // entao remove                              
                  })
                                                   
                  }
        })
      },

      async pegaParametrosUrl(){
            var params = window.location.search.substring(1).split('&');
            if(params[0] != ''){
            //Criar objeto que vai conter os parametros
            var paramArray = {};

            //Passar por todos os parametros
            for(var i=0; i<params.length; i++) {
                //Dividir os parametros chave e valor
                var param = params[i].split('=');

                //Adicionar ao objeto criado antes
                paramArray[param[0]] = param[1];
                }      
            if(paramArray['vendedor'])
            {
            await axios.get(`${baseApiUrl}Salesmans?filter[where][linkSite]=${paramArray['vendedor']}`).then(res => {        
                    if(res.data != null){
                    this.caarjS4E.codigoParceiro = parseInt(res.data[0].codeS4)
                    this.caarjS4EDefault.codigoParceiro = parseInt(res.data[0].codeS4)  
                    this.vendedor.nomeVendedor = res.data[0].linkSite    
                    this.vendedor.linkVendedor = true
                    this.vendedor.temVendedor = true
                    //this.vendedor.cpfVendedor = res.data[0].cpf
                    }              	
                    }) 
                }
            }
            },

           async consultaVendedor(){
             if(CpfValidate(this.vendedor.cpfVendedor)){
             await axios.get(`${baseApiUrl}Salesmans?filter[where][cpf]=${this.vendedor.cpfVendedor}`).then(res => {        
                if(res.data.length > 0){
                    this.caarjS4E.codigoParceiro = parseInt(res.data[0].codeS4)
                    this.caarjS4EDefault.codigoParceiro = parseInt(res.data[0].codeS4)  
                    this.vendedor.nomeVendedor = res.data[0].linkSite       
              }
              else{
              var vmcpfvend = this;
              vmcpfvend.$refs.chamaSnackbar.snack("#F9A825","Corretor não localizado!","ATENÇÃO");
              this.vendedor.nomeVendedor = '' 
              }
              })
           }
          }
        
}

}
</script>

<style>

    .link{
        font-size: 1.3rem;
        color: #194383;
        text-align: center;
    }
    .titulo{
        font-size: 2rem;
        color: #797a7a;
        text-align: center;
    }
    .imagemcaarj{
        background: url('https://www.apvs.com.br/assets/uploads/parceiros/caarj.png')no-repeat;
        background-size: 500px;
    }
    .imagemBanner{
       background: url("../Content/images/10.jpg"), linear-gradient(to right, #80CBC4, #00897B);
        background-repeat: no-repeat;
        position: relative;
        z-index: 1;
    }
</style>